import React, { Fragment, useEffect, useState } from 'react';
import { AuthenticatedRoute, UserAccess, UserHasAccess } from 'components/user-access';
import { PageRestricted } from 'pages/errors/page-restricted';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { Breadcrumbs, VerticalLinkGroup } from 'components/navigation';
import { AssetTypes, CostSupplier } from 'pages/fleet/fleet-settings';
import { EventTypeListing } from 'pages/fleet/fleet-settings/event-type/EventTypeListing';

export function FleetSettings(props) {
    const requiredActions = ["Fleet:ChangeAssetType","FMS:Manage"];
    const [currentRoute, setCurrentRoute] = useState([]);

    var defaultPath;

    var routes = [];

    if (UserHasAccess("Fleet:ChangeAssetType")) {
        routes.push({ location: "/fleet-settings/asset-types", title: "Asset Types" });
        defaultPath = "/fleet-settings/asset-types";
    }

    if (UserHasAccess("FMS:Manage")) {
        routes.push({ location: "/fleet-settings/event-types", title: "Event Types" });
        defaultPath = (defaultPath == null) ? "/fleet-settings/event-types" : defaultPath;
        
    }

    if (UserHasAccess("FMS:Manage")) {
        routes.push({ location: "/fleet-settings/cost-supplier", title: "Costs and Suppliers" });
        defaultPath = (defaultPath == null) ? "/fleet-settings/cost-supplier" : defaultPath;
    }

    var location = useLocation();

    useEffect(findCurrentRoute, [location]);

    function findCurrentRoute() {
        var result = routes.find((l) => {
            return location.pathname.indexOf(l.location) === 0;
        });

        setCurrentRoute([result]);
    }

    return (
        <UserAccess perform={requiredActions}
                yes={() => (
                    <Fragment>
                        <div className="row">

                            <Breadcrumbs items={props.breadcrumbs.concat(currentRoute)} />

                            <h2>Fleet Settings</h2>
                            <div className="intro-text">
                                <p>In this section you can configure your fleet settings.</p>
                            </div>
                        </div>

                        <div className="layout-cols">
                            <div className="col side-col">
                                <div className="row">
                                    <VerticalLinkGroup links={routes} exactRouteMatch={false}></VerticalLinkGroup>
                                </div>
                            </div>
                            <div className="col content-col">
                                <Routes>
                                    <Route path="" element={<Navigate to={defaultPath} replace />} />
                                    <Route path="asset-types" element={<AuthenticatedRoute action="Fleet:ChangeAssetType"><AssetTypes /></AuthenticatedRoute>} />
                                    <Route path="event-types/*" element={<AuthenticatedRoute action="FMS:Manage"><EventTypeListing /></AuthenticatedRoute>} />
                                    <Route path="cost-supplier/*" element={<AuthenticatedRoute action="FMS:Manage"><CostSupplier /></AuthenticatedRoute>} />
                                </Routes>
                            </div>


                        </div>
                    </Fragment>
            )}
            no={() => (
                <PageRestricted />
            )}
        />
    );
}